import { writeStoredContext } from '@modules/navegacao-v2/utils/context-storage'
import { NAV_CONTEXT } from './state'

const persistContext = ({ context, rootGetters }) => {
  const user = (rootGetters && rootGetters['user/currentUser']) || {}
  writeStoredContext(context, { userId: user.id_interno })
}

// enterClient: seleciona o cliente global (reusa user/addSearchClient, usado por
// 10+ telas) e entra no contexto cliente. O roteamento fica a cargo do componente
// que dispara a action (mantém a action testável sem o router).
const enterClient = ({ commit, dispatch, rootGetters }, client) => {
  dispatch('user/addSearchClient', client, { root: true })
  commit('SET_CONTEXT', NAV_CONTEXT.CLIENTE)
  persistContext({ context: NAV_CONTEXT.CLIENTE, rootGetters })
}

// backToGestao: volta ao contexto gestão SEM limpar o cliente selecionado
// (retorno barato ao mesmo cliente depois).
const backToGestao = ({ commit, rootGetters }) => {
  commit('SET_CONTEXT', NAV_CONTEXT.GESTAO)
  persistContext({ context: NAV_CONTEXT.GESTAO, rootGetters })
}

const setContext = ({ commit, rootGetters }, ctx) => {
  commit('SET_CONTEXT', ctx)
  persistContext({ context: ctx, rootGetters })
}

const applyContext = ({ commit }, ctx) => {
  commit('SET_CONTEXT', ctx)
}

export default { enterClient, backToGestao, setContext, applyContext }
